/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const LTICircledIcon = /*#__PURE__*/ createSvgIcon(
  'LTICircledIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`}>
            <circle cx={10} cy={10} r={10} fill="#E8EEF7" />
            <path
              d="M5.417 15.417c-.344 0-.638-.123-.883-.368a1.204 1.204 0 01-.367-.882v-1.25c0-.178.06-.326.18-.446s.268-.18.445-.18.325.06.445.18.18.268.18.446v1.25h8.75v-7.5h-8.75v1.25c0 .177-.06.325-.18.445a.605.605 0 01-.445.18.605.605 0 01-.446-.18.605.605 0 01-.18-.445v-2.5c0-.344.123-.638.368-.883s.539-.367.883-.367h8.75c.344 0 .638.122.883.367.244.245.367.539.367.883v8.75c0 .343-.123.638-.367.882-.245.245-.54.368-.883.368h-8.75zM9.9 11.042h-5.11a.605.605 0 01-.445-.18.605.605 0 01-.18-.445c0-.178.06-.326.18-.446s.269-.18.446-.18h5.11l-.86-.874a.61.61 0 01-.18-.43.582.582 0 01.18-.445.593.593 0 01.437-.172c.177 0 .323.057.438.172l1.937 1.937a.6.6 0 01.188.438.6.6 0 01-.188.437l-1.937 1.938a.61.61 0 01-.43.18.582.582 0 01-.445-.18.593.593 0 01-.172-.438c0-.177.057-.323.172-.437l.86-.875z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default LTICircledIcon;
